import { getServiceVersion, openStream, config } from '@wappsto/redux';
import equal from 'deep-equal';

const mainStream = 'stream-main';
let subscriptions: Record<string, number> = {};
const newSubscriptions: Record<string, number> = { ...subscriptions };
let timeout: ReturnType<typeof setTimeout>;
let ws: any;

let defaultOptions: any = {
  endPoint: 'websocket',
  version: '2.0',
};

export const STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  CANCELED: 'canceled',
} as const;

export const ITEMS_PER_SLICE = 100;

export function randomID(): string {
  return (Math.random() + 1).toString(36).substring(10);
}

export function getServiceUrl(service: string, options?: any): string {
  const version = options && options.version ? options.version : getServiceVersion(service);
  return `${config.baseUrl + (version ? `/${version}` : '')}/${service}`;
}

function updateSubscriptions(options: any): void {
  const subscriptionsKeys = Object.keys(subscriptions);
  const newSubscriptionsKeys = Object.keys(newSubscriptions);
  if (!equal(subscriptionsKeys, newSubscriptionsKeys)) {
    ws.send(
      JSON.stringify({
        jsonrpc: '2.0',
        method: 'PATCH',
        id: randomID(),
        params: {
          url: `${getServiceUrl(options.endPoint || options.service, options)}/open/subscription`,
          data: newSubscriptionsKeys,
        },
      }),
    );
  }
  subscriptions = { ...newSubscriptions };
}

export function setDefaultStreamOptions(options: any): void {
  defaultOptions = options;
}

export function updateStream(
  dispatch: any,
  subscription: string[],
  type: 'add' | 'remove',
  options: any = defaultOptions,
): void {
  clearTimeout(timeout);
  if (type === 'add') {
    subscription.forEach((path) => {
      newSubscriptions[path] = (newSubscriptions[path] || 0) + 1;
    });
  } else {
    subscription.forEach((path) => {
      newSubscriptions[path] = (newSubscriptions[path] || 0) - 1;
      if (newSubscriptions[path] < 1) {
        delete newSubscriptions[path];
      }
    });
  }
  timeout = setTimeout(async () => {
    if (!ws || ws.readyState !== ws.OPEN) {
      ws = await dispatch(
        openStream(
          { name: mainStream, subscription: [], full: options.full || false },
          undefined,
          options,
        ),
      );
      ws.addEventListener('open', () => updateSubscriptions(options));
    } else {
      updateSubscriptions(options);
    }
  }, 200);
}

export function cannotAccessState(state: any): boolean {
  return (
    state.status_payment === 'not_shared' ||
    state.status_payment === 'not_paid' ||
    state.status_payment === 'no_points' ||
    state.status_payment === 'open'
  );
}

export function countDecimals(value: number): number {
  const text = value.toString();
  if (text.indexOf('e-') > -1) {
    const trail = text.split('e-')[1];
    const deg = Number(trail);
    return deg;
  }
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0;
  }
  return 0;
}

export function roundBasedOnStep(
  number: number | string,
  step: number,
  min: number,
): number | string {
  const num = Number(number);
  let roundedNumber = num;
  if (Number.isNaN(num) || step === 0) {
    return number;
  }
  if (num - min + min === num) {
    roundedNumber = step * Math.round((num - min) / step) + min;
  }
  return roundedNumber.toFixed(countDecimals(step));
}
